import React from 'react';
import logo from "/assets/imgs/logo.png"
import {Box, useTheme} from "@mui/material";

function AuthLogo() {
    const theme = useTheme()
    return <Box
        sx={{
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: theme.palette.background.default
        }}
    >
        <img
            style={{width: 120, height: 120, minWidth: 120, objectFit: "cover",}}
            src={logo}
        />
    </Box>;
}

export default AuthLogo;
